<template lang="html">

  <div class="rating-component">

    <div class="stars" :style="{width: calculateSize, marginRight: difference}"></div>

    <div class="rating-info">{{ score }}</div>

  </div>

</template>

<script lang="js" type="text/javascript">

  import axios from 'axios';

  export default  {

    name: 'rating-component',

    props: ['product'],

    data(){
        return{

            score: 0

        }
    },

    computed:{

      calculateSize(){

          return this.score * 70 / 5 + 'px';

      },

      difference(){

        return 70 - this.score * 70 / 5 + 'px';

      },



    },

    mounted(){

      let vm = this;

      const MERCHANT_ID = 877647;

      const LOCALE = "en_US";

      const API_KEY = "7c4da1e0-28bd-4d6a-839e-7bced28cbe1b";

      const PAGE_SIZE = 1;

      if (!this.product) return;

      let product = this.product.toUpperCase();

          switch (product) {
                case 'AS1':
                    product = 132;
                    break;
                case 'AS2':
                    product = 128;
                    break;
                case 'AS3':
                    product = 130
                    break;
                case 'AS4':
                    product = 141;
                    break;
                case 'AS5':
                    product = 137;
                    break;
                default:
                    product = '';
          }

      let url = "https://readservices-b2c.powerreviews.com/m/" + MERCHANT_ID + "/l/" + LOCALE + "/product/" + product + "/reviews?paging.size=" + PAGE_SIZE + "&apikey=" + API_KEY + "&format=json";

      axios.get(url)

           .then(res => {return res})

           .then(data =>{

             vm.score = data.data.results[0].rollup.average_rating;

           }).catch(err => {
             console.error('[ERROR] Unable to load ratings', err)
           });

    }


  }
</script>



// WEBPACK FOOTER //
// src/components/shared/rating.vue